/**
 * Снять вид, которого в разрешённых районах кабинета не бывает.
 *
 * Подписка и ничего своего: вся проверяемая логика — в `clampSpeciesToScope`,
 * здесь только ответ сервера и вызов `setSpecies(null)`.
 *
 * ЖИВЁТ В `ViewProvider`, а не на странице. Выбор вида лежит НАД маршрутами и
 * переживает переход «Карты» ↔ «Аналитика»; проверка, подключённая к разделу,
 * отваливалась бы вместе с ним — а вид оставался бы выбранным.
 *
 * ЗАПРОС ВКЛЮЧАЕТСЯ ТОЛЬКО ПРИ ВЫБРАННОМ ВИДЕ. Провайдер обёрнут вокруг ВСЕГО
 * кабинета, включая разделы без карты («Суда», «Спутники», «Буи»), и
 * безусловный `useQuery` завёл бы им поход за каталогом видов, которого они не
 * спрашивают. Ключ тот же, что у четырёх остальных мест витрины, — на разделах
 * с картой второго запроса не возникает.
 */

import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'

import { cabinetApi } from '../api'
import { clampSpeciesToScope } from './speciesScope'

export function useSpeciesScopeClamp(
  species: number | null,
  setSpecies: (id: number | null) => void,
): void {
  const { data } = useQuery({
    queryKey: ['cabinet', 'species'],
    queryFn: () => cabinetApi.species(),
    enabled: species != null,
  })
  useEffect(() => {
    if (species == null) return
    // Отказ сервера (`region_forbidden`, обрыв сети) оставляет `data` пустым —
    // и выбор не трогается: снять вид из-за недоехавшего ответа значит стереть
    // человеку контекст на ровном месте.
    const kept = clampSpeciesToScope(species, data?.species ?? [], data?.regions ?? [])
    if (kept == null) setSpecies(null)
  }, [species, data, setSpecies])
}
